export function getFormattedHumanOSVersion(humanOSVersion?: string) {
  if (!humanOSVersion) {
    return null;
  }

  const formattedHumanOSVersion = humanOSVersion.toLowerCase();
  if (formattedHumanOSVersion === 'basicavatar') {
    return 'Basic Avatar';
  }

  if (formattedHumanOSVersion.includes('humanos')) {
    const version = formattedHumanOSVersion.split('humanos')[1];
    return `HumanOS ${version}`;
  }

  return null;
}
